// extracted by mini-css-extract-plugin
export default {"checkbox":"MGInputCheckbox_checkbox__Sr0st","input":"MGInputCheckbox_input__rScFo","visual":"MGInputCheckbox_visual__dcVGr","icon":"MGInputCheckbox_icon__Jitfr"};